import { all, takeLatest } from 'redux-saga/effects'
import {
	Types as TypesAuth,
	Authentication as AuthenticationSaga,
} from './auth'
export default function* Saga() {
	yield all[yield takeLatest(TypesAuth.AUTHENTICATION, AuthenticationSaga)]
}
